import IconSVG from '../../../styles/svg-icons';
import { SubscriptionFeature } from '../../../types/billing/SubscriptionFeature';
import { ActionBlocker } from '../../access/ActionBlocker';

export const ImSubscriptionValue = ({
    children,
    overrideRequiredFeatures,
}: {
    children: React.ReactNode;
    overrideRequiredFeatures?: boolean;
}) => {

    if (overrideRequiredFeatures) {
        return <>{children}</>;
    }

    return (
        <ActionBlocker
            overrideRequiredFeatures={overrideRequiredFeatures}
            feature={SubscriptionFeature.IssuanceMonitorFullAccess}
        >
            {(blocked) => blocked
                ? <IconSVG width="16" height="16" name="subscribe-lock-grey" />
                : <>{children}</>
            }
        </ActionBlocker>
    );
};
